import { setGameWindowContext } from '@/store/actions';
import { Account } from '@fanduel/cpe-um-bundle/account/library';
import { Logger } from '@/utilities/logger/datadog/rumEvents/rumEvents';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { walletBalanceWithRetry } from './get-balance-data-with-retry';

export const getBalanceData = async (
  callback?: (balance: number | null) => void,
) => {
  setGameWindowContext({ loadingGetBalance: true });

  Logger.logRumAction({
    name: '[GW][GET_BALANCE_DATA] AW Get Balance Initiated',
    useCase: DdEventCategory.Wallet,
    eventType: DdEventType.Info,
    logOnly: true,
    event: { action: 'AW Get Balance Initiated', log_code: 'GW-110' },
  });

  try {
    const balances = await walletBalanceWithRetry();

    Logger.logRumAction({
      name: '[GW][GET_BALANCE_DATA] AW Get Balance Succeeded',
      useCase: DdEventCategory.Wallet,
      eventType: DdEventType.Success,
      logOnly: true,
      context: {
        inGameBalanceActive: Boolean(balances?.inGameBalanceActive),
        hasPlayableBalance: typeof balances?.playableBalance === 'number',
        hasTotalBalance: typeof balances?.total === 'number',
      },
      event: {
        action: 'AW Get Balance Succeeded',
        log_code: 'GW-210'
      },
    });

    setGameWindowContext({
      loadingGetBalance: false,
      errorGetBalance: false,
      balanceDetails: balances,
    });

    if (callback) {
      const inGameTotal =
        balances?.inGameBalanceActive &&
        typeof balances.total === 'number' &&
        Number.isFinite(balances.total)
          ? balances.total
          : null;

      const clientBalance = inGameTotal ?? balances?.playableBalance ?? null;

      callback(clientBalance);
    }
  } catch (error) {
    Logger.logRumError({
      name: '[GW][GET_BALANCE_DATA] AW Get Balance Failed',
      useCase: DdEventCategory.Wallet,
      eventType: DdEventType.Error,
      logOnly: true,
      context: {
        errorMessage: error instanceof Error ? error.message : String(error),
      },
      event: {
        action: 'AW Get Balance Failed',
        log_code: 'GW-510'
      },
    });

    await Account.checkValidSession();

    setGameWindowContext({
      loadingGetBalance: false,
      errorGetBalance: true,
      balanceDetails: null,
    });
  }
};

export default getBalanceData;
